import createIcon from './createIcon';

export default createIcon(require('./helmet.svg'));